import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Login from './login';
import { Box, Tooltip } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { useDrawerOpenFun } from "../Context/modelContext";

export default function LoginModel() {
    const { loginModal, setLoginModal } = useDrawerOpenFun();

    const handleClose = () => {
        setLoginModal(false);
    };

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth={'xxl'}
                open={loginModal}
                onClose={handleClose}
            >
                <Box sx={{ position: 'absolute', top: 10, right: 10 }}>
                    <Tooltip title="Close" arrow placement="left">
                        <CancelIcon
                            onClick={handleClose}
                            sx={{ cursor: 'pointer', color: 'primary.main' }}
                        />
                    </Tooltip>
                </Box>
                <Login />
            </Dialog>
        </>
    );
}
